import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import withNotify from '../../common/withNotify';
import withGoBack from '../../common/withGoBack';
import {
  ALPHANUMERIC,
  getTeamData,
  getTerritoryData,
  getUser,
  onGoBack,
  renderAlphabetically
} from '../../common/globals';
import withLoader from '../../common/withLoader';
import withOnline from '../../common/withOnline';
import withSetsSearch from '../../common/withSetsSearch';
import withOfficeSetsFilter from '../../common/withOfficeSetsFilter';
import Header from '../../components/Header';
import CaseType from '../../components/ManageCase/CaseType';
import Components from '../../components/ManageCase/Components';
import Locations from '../../components/ManageCase/Locations';
import SetsMasterGroup from '../../components/ManageCase/SetsMasterGroup';
import { getSetMaster, getSetGroupByGroupName } from '../../utils/db';
import { searchSets, initAPIController } from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import BarcodeIcon from '../../assets/images/barcode-scan-custom.png';

class OfficeSets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      officeSetsData: [],
      masterOfficeSetsData: [],
      officeSetsGroupData: [],
      selectedId: '',
      search: '',
      isSearch: false,

      procedureType: '',
      deviceType: '',
      selectedType: '',
      isCaseType: false,
      selectedLocation: '',
      selectedLocationAbb: '',
      isLocation: false,
      selectedComponent: '',
      isComponent: false,
      isGroup: false,
      selectedSetGroup: ''
    };
    this.apiController = null;
  }

  _onSearch = () => {
    try {
      const { isSearch, masterOfficeSetsData } = this.state;
      const { online, setSetsSearch } = this.props;
      this.setState({ isSearch: !isSearch }, () => this._onSearchFocusAndBlur());
      if (online) {
        if (isSearch) {
          setSetsSearch({});
          this.setState({
            search: '',
            officeSetsData: masterOfficeSetsData
          }, () => this._onFilter());
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onFilter = async () => {
    try {
      const {
        officeSetsData, procedureType, deviceType, selectedType, selectedComponent, selectedSetGroup
      } = this.state;
      const { online, notify } = this.props;

      if (online) {
        let groupArr = [];
        if (selectedSetGroup !== '' || selectedSetGroup === undefined) {
          const setGroupRes = await getSetGroupByGroupName(selectedSetGroup);
          groupArr = setGroupRes[0].SetNames !== null
            ? setGroupRes[0].SetNames.split(';') : [];
        }

        let data = [...officeSetsData];

        if (procedureType !== '') {
          // data = (data.filter((item) => item.ProcedureType === procedureType));
          data = data.filter(
            (item) => item.ProcedureType.includes(procedureType)
          );
        }
        if (deviceType !== '') {
          // data = (data.filter((item) => item.DeviceType === deviceType));
          data = data.filter(
            (item) => item.DeviceType.includes(deviceType)
          );
        }
        if (selectedType !== '' || selectedType === undefined) {
          // data = (data.filter((item) => item.CaseType === selectedType));
          data = data.filter(
            (item) => item.CaseType.includes(selectedType)
          );
        }

        if (selectedComponent !== '' || selectedComponent === undefined) {
          // data = (data.filter((item) => item.Component === selectedComponent));
          data = data.filter(
            (item) => item.Component.includes(selectedComponent)
          );
        }

        if (selectedSetGroup !== '' || selectedSetGroup === undefined) {
          const setGroup = [];
          data.map((value) => {
            if (groupArr.includes(value.SetName)) {
              setGroup.push(value);
            }
          });
          data = setGroup;
        }

        const sortObj = renderAlphabetically(data, 'SetName');

        this.setState({
          officeSetsGroupData: sortObj
        });
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to sync data.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProcedureTypeClick = (event) => {
    try {
      let { procedureType } = this.state;
      (procedureType === event.target.value)
        ? procedureType = ''
        : procedureType = event.target.value;
      this.setState({ procedureType }, () => { this._onFilter(); });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDeviceTypeClick = (event) => {
    try {
      let { deviceType } = this.state;
      (deviceType === event.target.value)
        ? deviceType = ''
        : deviceType = event.target.value;
      this.setState({ deviceType }, () => this._onFilter());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseTypeClick = () => {
    try {
      const { isCaseType, selectedType } = this.state;
      if (selectedType !== '') {
        this.setState({ selectedType: '' }, () => { this._onFilter(); });
      } else {
        this.setState({ isCaseType: !isCaseType });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseLocationClick = () => {
    try {
      const { isLocation, selectedLocation } = this.state;
      if (selectedLocation !== '') {
        this.setState({ selectedLocation: '', selectedLocationAbb: '' }, () => {
          this._onSetSearch('', () => {
            this._onFilter();
          });
        });
      } else {
        this.setState({ isLocation: !isLocation });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onComponentClick = () => {
    try {
      const { isComponent, selectedComponent } = this.state;
      if (selectedComponent !== '') {
        this.setState({ selectedComponent: '' }, () => { this._onFilter(); });
      } else {
        this.setState({ isComponent: !isComponent });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedCaseType = (selectedType) => {
    try {
      const { isCaseType } = this.state;
      if (selectedType === '' || selectedType === undefined) {
        this.setState({ isCaseType: !isCaseType });
      } else {
        this.setState({ selectedType: selectedType.OptionName, isCaseType: !isCaseType },
          () => { this._onFilter(); });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedCaseLocation = (selectedLocation) => {
    try {
      const { isLocation } = this.state;
      if (selectedLocation === '' || selectedLocation === undefined) {
        this.setState({ isLocation: !isLocation });
      } else {
        this.setState(
          {
            selectedLocation: selectedLocation.LocName,
            selectedLocationAbb: selectedLocation.LocAbb,
            isLocation: !isLocation
          },
          () => {
            this._onSetSearch('', () => {
              this._onFilter();
            });
          }
        );
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOfficeSetsBack = () => {
    try {
      this.setState({
        isCaseType: false,
        isLocation: false,
        isComponent: false,
        isGroup: false
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedComponent = (selectedComponent) => {
    try {
      const { isComponent } = this.state;
      if (selectedComponent === '' || selectedComponent === undefined) {
        this.setState({ isCaseType: !isComponent });
      } else {
        this.setState({ selectedComponent: selectedComponent.Component, isComponent: !isComponent },
          () => { this._onFilter(); });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedSetsGroup = (selectedSetGroup) => {
    try {
      const { isGroup } = this.state;
      if (selectedSetGroup === '' || selectedSetGroup === undefined) {
        this.setState({ isGroup: !isGroup });
      } else {
        this.setState({ selectedSetGroup: selectedSetGroup.SetGroup, isGroup: !isGroup },
          () => { this._onFilter(); });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickGroup = () => {
    try {
      const { isGroup, selectedSetGroup } = this.state;
      if (selectedSetGroup !== '') {
        this.setState({ selectedSetGroup: '' }, () => {
          this._onFilter();
        });
      } else {
        this.setState({ isGroup: !isGroup });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetSearch = async (search, callback = false) => {
    try {
      const {
        online, setSetsSearch, setLoader, notify, setsSearch
      } = this.props;
      const { masterOfficeSetsData } = this.state;
      this.setState({ search });
      const searchData = {
        search_term: search,
        set_type: 'officeset',
        location_name: this.state.selectedLocation
      };

      if (search.length > 2 || search.length === 0) {
        if (online) {
          setLoader(true);
          if (this.apiController) {
            this.apiController.abort();
          }
          this.apiController = initAPIController();
          searchSets(searchData).then((response) => {
            const { status, data } = response;
            const officeSetsGroupData = renderAlphabetically(data, 'SetName');
            if (status) {
              this.setState({
                officeSetsData: data,
                officeSetsGroupData
              }, () => {
                callback && callback();
              });
              setSetsSearch({
                search,
                isSearch: search.length !== 0,
                officeSetsGroupData
              });
            }
            if (search.length < 2 && search.length !== 0) {
              setTimeout(() => {
                this.setState({
                  officeSetsData: masterOfficeSetsData,
                  officeSetsGroupData: renderAlphabetically(masterOfficeSetsData, 'SetName')
                }, () => {
                  callback && callback();
                });
              }, 500);
            }
          }).catch(async () => {
            if (search.length < 2) {
              setSetsSearch({
                isSearch: search.length !== 0,
                officeSetsGroupData: renderAlphabetically(masterOfficeSetsData, 'SetName'),
                search,
              });
              this.setState({
                officeSetsData: masterOfficeSetsData,
                officeSetsGroupData: renderAlphabetically(masterOfficeSetsData, 'SetName')
              }, () => {
                callback && callback();
              });
            }
          });
          setLoader(false);
        } else {
          notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 5 });
        }
      } else {
        if (this.apiController) {
          this.apiController.abort();
        }
        const officeSetsData = await getSetMaster();
        const officeSetsGroupData = renderAlphabetically(officeSetsData, 'SetName');
        setTimeout(() => {
          setSetsSearch({
            isSearch: setsSearch.hasOwnProperty('isSearch') ? setsSearch.isSearch : false,
            officeSetsGroupData,
            search: '',
          });
          this.setState({ officeSetsGroupData, officeSetsData }, () => {
            callback && callback();
          });
        }, 1000);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBackSetInfo = () => {
    try {
      const { goBack, setSetsSearch, setOfficeSetsFilter } = this.props;
      onGoBack(goBack);
      setSetsSearch({});
      setOfficeSetsFilter({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickOfficeSets = (data) => {
    try {
      const { setOfficeSetsFilter } = this.props;
      const {
        procedureType,
        deviceType,
        selectedType,
        isCaseType,
        selectedComponent,
        selectedLocation,
        selectedLocationAbb,
        isComponent,
        isGroup,
        selectedSetGroup
      } = this.state;
      setOfficeSetsFilter({
        procedureType,
        deviceType,
        selectedType,
        isCaseType,
        selectedComponent,
        selectedLocation,
        selectedLocationAbb,
        isComponent,
        isGroup,
        selectedSetGroup
      });
      this._onGoBack();
      browserHistory.push(`/inventory/${encodeURIComponent(data.SetName)}/officeSets`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScanToMove = () => {
    const {
      online, setGoBack, goBack, notify
    } = this.props;
    if (!online) {
      notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 5 });
      return;
    }
    setGoBack([...goBack, window.location.pathname]);
    browserHistory.push('/move-sets');
  }

  _onSearchFocusAndBlur = () => {
    try {
      const { isSearch } = this.state;
      (!isSearch) ? window.$('#search').blur() : window.$('#search').focus();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { setsSearch } = this.props;
      const officeSetsData = await getSetMaster();
      const officeSetsGroupData = renderAlphabetically(officeSetsData, 'SetName');
      const search = setsSearch.hasOwnProperty('search') ? setsSearch.search : '';
      const { officeSetsFilter } = this.props;

      this.setState({
        masterOfficeSetsData: officeSetsData,
        officeSetsData,
        officeSetsGroupData: setsSearch.hasOwnProperty('officeSetsGroupData') ? setsSearch.officeSetsGroupData : officeSetsGroupData,
        isSearch: setsSearch.hasOwnProperty('isSearch') ? setsSearch.isSearch : false,
        search,
        ...officeSetsFilter
      }, () => this._onSearchFocusAndBlur());

      this._onSetSearch(search, () => {
        this._onFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render = () => {
    const { online } = this.props;
    const {
      officeSetsGroupData, isSearch, selectedType, isCaseType,
      selectedLocationAbb, isLocation, search, selectedComponent, isComponent,
      selectedSetGroup, isGroup
    } = this.state;
    const user = getUser();
    return (
      <section className="list-section">
        {
          <Header
            title={isCaseType ? 'Type' : isLocation ? 'Location'
              : isComponent ? 'Components' : isGroup ? 'Group' : 'Office Sets'}
            goBack={isCaseType
              ? this._onOfficeSetsBack : isLocation
                ? this._onOfficeSetsBack : isComponent
                  ? this._onOfficeSetsBack : isGroup
                    ? this._onOfficeSetsBack : this._onGoBackSetInfo}
          />
        }
        {
          !isGroup
            ? !isComponent
              ? !isLocation
                ? (!isCaseType) ? (
                  <>
                    <section
                      className="sets-section"
                      style={{ marginBottom: '50px' }}
                    >
                      <div className="container">
                        <div className="top-block sticky-sets-info">
                          <div className="right-block">
                            <div className="row gx-2">
                              <div className="col">
                                {
                                  officeSetsGroupData.length > 0
                                    ? <p className="mb-0" style={{ fontWeight: '600' }}>Sets</p> : ''
                                }
                              </div>
                              <div className="col-auto align-self-center">
                                {
                                  officeSetsGroupData.length > 0 ? (
                                    <Link className="me-3">
                                      <i
                                        className="fas fa-search theme-color-yellow cursor-pointer"
                                        onClick={this._onSearch}
                                      />
                                    </Link>
                                  ) : ''
                                }
                              </div>
                            </div>
                          </div>
                          {
                            (isSearch === true) && (
                              <div className="row gx-2 mt-2">
                                <div className="col-12">
                                  <div className="search-box mb-2 me-10">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search"
                                      value={search}
                                      id="search"
                                      onChange={({ target: { value } }) => {
                                        this._onSetSearch(value, () => {
                                          this._onFilter();
                                        });
                                      }}
                                    />
                                    <span className="icon"><i className="fas fa-search cursor-pointer" /></span>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        </div>
                        <div className="sets-list-blocks t-b-border-0">
                          {
                            officeSetsGroupData.length > 0
                              ? (
                                officeSetsGroupData.map((item, index) => (
                                  <div className="sets-block" key={index}>
                                    <h4 id={item.group.toLowerCase()}>{item.group}</h4>
                                    <ul className="list-unstyled" key={index}>
                                      {
                                        item.children.map((data, key) => (
                                          <li key={key}>
                                            <div className="right-side">
                                              <Link
                                                className="link-set-content cursor-pointer"
                                                onClick={() => this._onClickOfficeSets(data)}
                                              >
                                                {data.SetName}
                                              </Link>
                                            </div>
                                          </li>
                                        ))
                                      }
                                    </ul>
                                  </div>
                                ))
                              ) : (
                                <p className="text-center">No sets match to your filters</p>
                              )
                          }
                        </div>

                      </div>

                      {
                        officeSetsGroupData.length > 0 && (
                          <ul className="list-unstyled right-filter mt-3">
                            {ALPHANUMERIC.map((name, index) => (
                              <li key={index}>
                                <a href={`/inventory/officeSets#${name.toLowerCase()}`} key={index}>{name}</a>
                              </li>
                            ))}
                          </ul>
                        )
                      }
                    </section>

                    <section className="sets-footer-section fixed-bottom">
                      <div className="sets-footer-inner">
                        <div className="container">
                          <div className="button-block" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <div className="button-scrollarea">
                              {
                                getTerritoryData(user).isSetMove && getTeamData(user).isSetMove ? (
                                  <div>
                                    <a
                                      role="button"
                                      tabIndex={0}
                                      style={{ display: 'inline-block', width: 29 }}
                                      onClick={this._onScanToMove}
                                    >
                                      <img style={{ width: 29 }} src={BarcodeIcon} alt="barcode-icon" />
                                    </a>
                                  </div>
                                ) : null
                              }
                              <div>
                                <button
                                  type="button"
                                  className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${selectedLocationAbb ? 'active' : ''}`}
                                  style={{ minWidth: 100 }}
                                  onClick={this._onCaseLocationClick}
                                >
                                  {selectedLocationAbb || 'Location'}
                                </button>
                              </div>
                              <div>
                                <button
                                  type="button"
                                  className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${selectedType ? 'active' : ''}`}
                                  style={{ width: 100 }}
                                  onClick={this._onCaseTypeClick}
                                >
                                  {selectedType || 'Type'}
                                </button>
                              </div>
                              <div>
                                <div className="btn-group" role="group">
                                  <button
                                    type="button"
                                    className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${this.state.deviceType === 'IMPLANT' ? 'active' : ''}`}
                                    value="IMPLANT"
                                    style={{ width: 90 }}
                                    onClick={(e) => this._onDeviceTypeClick(e)}
                                  >Implant
                                  </button>
                                  <button
                                    type="button"
                                    className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${this.state.deviceType === 'INSTRUMENT' ? 'active' : ''}`}
                                    value="INSTRUMENT"
                                    style={{ width: 90 }}
                                    onClick={(e) => this._onDeviceTypeClick(e)}
                                  >Instrument
                                  </button>
                                </div>
                              </div>
                              <div>
                                <div className="btn-group" role="group">
                                  <button
                                    type="button"
                                    className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${this.state.procedureType === 'PRIMARY' ? 'active' : ''}`}
                                    value="PRIMARY"
                                    style={{ width: 90 }}
                                    onClick={(e) => this._onProcedureTypeClick(e)}
                                  >Primary
                                  </button>
                                  <button
                                    type="button"
                                    className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${this.state.procedureType === 'REVISION' ? 'active' : ''}`}
                                    value="REVISION"
                                    style={{ width: 90 }}
                                    onClick={(e) => this._onProcedureTypeClick(e)}
                                  >Revision
                                  </button>
                                </div>
                              </div>
                              <div>
                                <button
                                  type="button"
                                  className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${selectedSetGroup ? 'active' : ''}`}
                                  style={{ width: 100 }}
                                  onClick={this._onClickGroup}
                                >{selectedSetGroup || 'Group'}
                                </button>
                              </div>
                              <div>
                                <button
                                  type="button"
                                  className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${selectedComponent ? 'active' : ''}`}
                                  style={{ width: 100 }}
                                  onClick={this._onComponentClick}
                                > {selectedComponent || 'Component'}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </>
                )
                  : (
                    <CaseType
                      onHideShowCaseType={this._onSelectedCaseType}
                    />
                  )
                : (
                  <Locations
                    online={online}
                    onHideShowLocation={this._onSelectedCaseLocation}
                  />
                ) : (
                  <Components
                    onSelectedComponent={this._onSelectedComponent}
                    setInfo
                  />
              )
            : (
              <SetsMasterGroup
                onSelectedSetsGroup={this._onSelectedSetsGroup}
                setInfo
              />
            )
        }
      </section>
    );
  }
}

export default withOfficeSetsFilter(
  withSetsSearch(
    withOnline(
      withGoBack(
        withNotify(
          withLoader(
            OfficeSets
          )
        )
      )
    )
  )
);
